<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="新增付款"
      width="500"
      :open="open"
      @close="close"
      class="create-dialog"
    >
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <!-- <mu-form-item prop="customer" label="客户">
          <mu-text-field v-model="form.customer"></mu-text-field>
        </mu-form-item> -->

        <mu-form-item prop="money" label="记账金额">
          <mu-text-field v-model.number="form.money"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="realMoney" label="付款金额">
          <mu-text-field v-model.number="form.realMoney"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="account" label="收款账户">
          <mu-select v-model="form.account">
            <mu-option
              v-for="(item, index) in accountList"
              :key="index"
              :label="item.name"
              :value="item"
            ></mu-option>
          </mu-select>
        </mu-form-item>

        <mu-form-item prop="remark" label="备注">
          <mu-text-field v-model="form.remark"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button
        slot="actions"
        color="primary"
        @click="submit"
        v-loading="loading"
        >提交</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    customer: {
      type: Object
    },
    total: {
      type: Number
    }
  },
  data() {
    return {
      form: {
        customer: {},
        money: '',
        realMoney: '',
        remark: '',
        account: ''
      },
      accountList: [],
      loading: false
    }
  },
  methods: {
    submit() {
      if (this.form.money > this.total) {
        this.$toast.error('付款金额不能大于总欠款')
        return
      }
      if (this.form.account.id === undefined) {
        this.$toast.error('请选择账户')
        return
      }
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          this.loading = true
          backend(api.payment.create, this.form).then((result) => {
            this.loading = false
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form.money = ''
              this.form.realMoney = ''
              this.form.remark = ''
              this.form.account = ''
              this.getCompanyAccount()
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getCompanyAccount() {
      backend(api.account.getCompanyAccount).then((result) => {
        if (result.statusCode === 200) {
          this.accountList = result.data
        }
      })
    }
  },
  watch: {
    customer(val) {
      this.form.customer = val
    },
    'form.money': {
      handler(val) {
        this.form.realMoney = val
      },
      deep: true
    }
  },
  mounted() {
    this.getCompanyAccount()
  }
}
</script>

<style lang="less" scoped>
.create-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/payment/create.vue